var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsMoreHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.667 729.167C260.389 729.167 295.833 693.723 295.833 650.001C295.833 606.278 260.389 570.834 216.667 570.834C172.944 570.834 137.5 606.278 137.5 650.001C137.5 693.723 172.944 729.167 216.667 729.167Z",
    className: "svgStroke",
    strokeWidth: 50
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 729.167C693.723 729.167 729.167 693.723 729.167 650.001C729.167 606.278 693.723 570.834 650 570.834C606.278 570.834 570.833 606.278 570.833 650.001C570.833 693.723 606.278 729.167 650 729.167Z",
    className: "svgStroke",
    strokeWidth: 50
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.33 729.167C1127.06 729.167 1162.5 693.723 1162.5 650.001C1162.5 606.278 1127.06 570.834 1083.33 570.834C1039.61 570.834 1004.17 606.278 1004.17 650.001C1004.17 693.723 1039.61 729.167 1083.33 729.167Z",
    className: "svgStroke",
    strokeWidth: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsMoreHorizontal);
export default __webpack_public_path__ + "static/media/akar-icons_more-horizontal.881726e9.svg";
export { ForwardRef as ReactComponent };